@let hovered = lastHoveredStar();
@let filled = filledStars();
@let allFilled = allFilledStarsLength();
@for (i of filled; track i) {
  <span
    class="star"
    [class.previous-hovered]="hovered && i < hovered"
    (click)="setRating(i + 1)"
    (mouseover)="hoverStar(i + 1)"
    (mouseout)="hoverStar(null)"
  >
    <i class="fas fa-star"></i>
  </span>
}
@if (hasHalfStar()) {
  <span
    class="star"
    [class.previous-hovered]="hovered && filled.length < hovered"
    (click)="setRating(filled.length + 1)"
    (mouseover)="hoverStar(filled.length + 1)"
    (mouseout)="hoverStar(null)"
  >
    <i class="fas fa-star-half-alt"></i>
  </span>
}
@for (i of emptyStars(); track i) {
  <span
    class="star"
    [class.previous-hovered]="hovered && allFilled + i < hovered"
    (click)="setRating(allFilled + 1 + i)"
    (mouseover)="hoverStar(allFilled + 1 + i)"
    (mouseout)="hoverStar(null)"
  >
    <i class="far fa-star"></i>
  </span>
}
